import { type Position } from "#/types/positions";
import { isOptionInstrument } from "#/utils/instrument.utils";

import { totalRowInstrument } from "./AllPositions.constants";

export const getAllPositionRows = (data: Position[]): Position[] => {
  if (data.length === 0) return [];

  const emptyFields = {
    maturity: "",
    size: 0,
    value: 0,
    avgPrice: 0,
    markPrice: 0,
    delta: 0,
    gamma: 0,
    vega: 0,
    theta: 0,
    rho: 0,
    accruedFunding: 0,
  };

  const summary = data.reduce(
    (acc, position) => {
      const { instrumentType } = position;

      acc[instrumentType].count += 1;
      acc[instrumentType].pnl += position.pnl ?? 0;
      acc[instrumentType].delta += position.delta ?? 0;

      if (isOptionInstrument(instrumentType)) {
        acc.options.gamma += position.gamma ?? 0;
        acc.options.vega += position.vega ?? 0;
        acc.options.theta += position.theta ?? 0;
        acc.options.rho += position.rho ?? 0;
      } else {
        acc.perps.accruedFunding += position.accruedFunding ?? 0;
      }

      return acc;
    },
    {
      options: {
        count: 0,
        pnl: 0,
        delta: 0,
        gamma: 0,
        vega: 0,
        theta: 0,
        rho: 0,
      },
      perps: {
        count: 0,
        delta: 0,
        pnl: 0,
        accruedFunding: 0,
      },
    },
  );

  const result: Position[] = [];

  if (summary.options.count && summary.perps.count) {
    result.push({
      ...emptyFields,
      instrument: totalRowInstrument,
      instrumentType: "perps",
      accruedFunding: summary.perps.accruedFunding,
      pnl: summary.options.pnl + summary.perps.pnl,
      delta: summary.options.delta + summary.perps.delta,
    });
  }

  if (summary.options.count) {
    result.push({
      ...emptyFields,
      instrument: `Options (${summary.options.count})`,
      instrumentType: "options",
      pnl: summary.options.pnl,
      delta: summary.options.delta,
      gamma: summary.options.gamma,
      vega: summary.options.vega,
      theta: summary.options.theta,
      rho: summary.options.rho,
    });
  }

  if (summary.perps.count) {
    result.push({
      ...emptyFields,
      instrument: `Perps (${summary.perps.count})`,
      instrumentType: "perps",
      accruedFunding: summary.perps.accruedFunding,
      pnl: summary.perps.pnl,
      delta: summary.perps.delta,
    });
  }

  return result;
};
